module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a7-1-5b169423830e798ce9fab17e676f3ddf.jpg";